// extracted by mini-css-extract-plugin
export default {"scroll-chat-main":"ScrollChat_scroll-chat-main__etn39","single-chat":"ScrollChat_single-chat__3ebvU","user":"ScrollChat_user__HgA5K","gemini":"ScrollChat_gemini__qdAeQ"};